export const ABTesting = {
    data() {
        return {
            version: window.abTesting
        }
    },
    methods: {
        getVersion() {
            return this.version
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/abtesting.js